module.exports = __webpack_public_path__ + "assets/img/3.2ccc7650.jpg";